// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1G1dO","ranges":"BmiRanges_ranges__26xJe"};